import ApiService from "./apiService";

export async function getInstituteCourses() {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/public/courses/home`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function searchCourse(courseId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/public/find/`+courseId;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function searchCertificatesGeneratedEnrolls() {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/enroll/certificate`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function searchCourseCertificateById(id) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = false;
    apiObject.endpoint = `student/public/certificate/${id}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function searchCourseLesson(courseId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/public/course/getLessons/`+courseId;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function joinToLessonUnauthorized(courseId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/${courseId}/join`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}
export async function joinToLessonAuthorized(courseId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/authorized/joinZoom/${courseId}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function courseEnroll(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/enroll`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function courseDepositSlip(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/payment/deposit`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function courseEnrollUsingCard(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/payment/card`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function enrollClassPayment(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/payment/card/complete`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}

export async function getZoomDetails(meetingId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/courses/getZoomDetails/${meetingId}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

